import React, { useEffect, useRef, useState } from 'react';
import '../../../Assets/Css/ViewProject.scss';
import { connect } from 'react-redux';
import { customStyle } from '../../../Components/Style'
import Select from 'react-select'
import { PieChart } from '@mui/x-charts/PieChart';
import { Gauge } from '@mui/x-charts/Gauge';
import { BsThreeDotsVertical } from "react-icons/bs";
import userImg from '../../../Assets/Images/Project/userimg.jpg'
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const initialState = {
    projectstatus: { value: 'In_Progress', label: 'In Progress', color: '#00B5FF' }
}

const ProjectStatus = [
    { value: 'In_Progress', label: 'In Progress', color: '#00B5FF' },
    { value: 'Not_Started', label: 'Not Started', color: 'gray' },
    { value: 'On_Hold', label: 'On Hold', color: '#F5C308' },
    { value: 'Cancelled', label: 'Cancelled', color: '#D21010' },
    { value: 'Finished', label: 'Finished', color: '#679C0D' }
];


const ViewProject = (props) => {
    const [activeTab, setActiveTab] = useState('overview');
    const [showDropdown, setShowDropdown] = useState(false);
    const [clientData, setClientData] = useState(initialState);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const handleDropdownToggle = () => {
        setShowDropdown(prevState => !prevState);
    };

    const handleEdit = () => {
        navigate('/employees/view/project/add');
    };

    const handleDelete = async () => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover the deleted record!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5757FE",
            cancelButtonColor: "transparent",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            customClass: {
                cancelButton: 'custom-cancel-button',
            },
        });

        if (result.isConfirmed) {
            Swal.fire({
                title: "Deleted!",
                text: "Your record has been deleted.",
                icon: "success"
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="viewProject-main">
            <div className="page-title">
                <h4>Camelab</h4>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="project-detail">
                                    <div className="row">
                                        <div className={`col-6 tab-column ${activeTab === 'overview' ? 'active' : ''}`}>
                                            <button
                                                className="custom-nav-link"
                                                onClick={() => setActiveTab('overview')}
                                            >
                                                Overview
                                            </button>
                                        </div>
                                        <div className={`col-6 tab-column ${activeTab === 'activity' ? 'active' : ''}`}>
                                            <button
                                                className="custom-nav-link"
                                                onClick={() => setActiveTab('activity')}
                                            >
                                                Activity
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {activeTab === 'overview' && (
                <>
                    <div className="custom-rows">
                        <div>
                            <div className="action-button-container" ref={dropdownRef}>
                                <button onClick={handleDropdownToggle} className="action-button">
                                    Actions <BsThreeDotsVertical className="action-icon" />
                                </button>
                                {showDropdown && (
                                    <div className="action-dropdown-menu">
                                        <button onClick={handleEdit} className="action-dropdown-item">Edit</button>
                                        <button className="action-dropdown-item">Task Board</button>
                                        <button className="action-dropdown-item">Pin Project</button>
                                        <button onClick={handleDelete} className="action-dropdown-item">Delete</button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div>
                            <div className="input-group">
                                <Select
                                    options={ProjectStatus}
                                    styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 2,
                                            width: '100%',
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            boxShadow: 'none',
                                            border: '1px solid #ced4da',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#6c757d',
                                        }),
                                    }}
                                    value={clientData.projectstatus}
                                    placeholder="---"
                                    onChange={(val) => {
                                        setClientData((preVal) => ({
                                            ...preVal,
                                            projectstatus: val
                                        }));
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                        },
                                    })}
                                    isSearchable
                                    getOptionLabel={(e) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span
                                                style={{
                                                    height: '12px',
                                                    width: '12px',
                                                    backgroundColor: e.color,
                                                    borderRadius: '50%',
                                                    display: 'inline-block',
                                                    marginRight: '10px',
                                                    marginLeft: '10px'
                                                }}
                                            />
                                            {e.label}
                                        </div>
                                    )}
                                    getOptionValue={(e) => e.value}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="content-part">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="left-part">
                                    <div className="custom-row">
                                        <div className="project-detail">
                                            <h5 className='project-progress-label'>Project Progress</h5>
                                            <div className="project-progress">
                                                <div>
                                                    <Gauge width={100} height={100} value={85} startAngle={-90} endAngle={90} />
                                                </div>
                                                <div className="input-groups-project">
                                                    <h6 className='labels'>Start Date</h6>
                                                    <h6>01-08-2024</h6>
                                                </div>
                                                <div className="input-groups-project">
                                                    <h6 className='labels'>Deadline</h6>
                                                    <h6>---</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="left-part">
                                    <div className="custom-row">
                                        <div className="project-detail">
                                            <h5 className='imgPart'>Client</h5>
                                            <div className='d-flex'>
                                                <img src={userImg} className='userImg' />
                                                <h6 className='label-user'>Ashwin</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-part">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="left-part">
                                    <div className="custom-row">
                                        <div className="project-detail">
                                            <div className="row">
                                                <h5 className='project-task-label'> Tasks </h5>
                                                <PieChart
                                                    className='pie-chart'
                                                    series={[
                                                        {
                                                            data: [
                                                                { id: 0, value: 10, label: 'Incomplete', color: '#D21010' },
                                                                { id: 1, value: 15, label: 'To Do', color: '#F5C308' },
                                                                { id: 2, value: 20, label: 'Doing', color: '#00B5FF' },
                                                                { id: 3, value: 25, label: 'Completed', color: '#679C0D' },
                                                                { id: 4, value: 30, label: 'Approved', color: '#007900' },
                                                            ],
                                                        },
                                                    ]}
                                                    width={400}
                                                    height={200}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="left-part">
                                    <div className="custom-row">
                                        <div className="project-detail">
                                            <div className="row">
                                                <h5>Statistics</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    loading: state.clientsReducer.loading,
    shareholdersList: state.shareholdersReducer.shareholderslist,
    invoicesList: state.invoicesReducer.invoiceslist,
});

const mapDispatchToProps = (dispatch) => ({
    getShareholdersList: () => dispatch(getShareholdersList()),
    getInvoicesList: () => dispatch(getInvoicesList()),
    addClient: (data) => dispatch(addClient(data)),
    updateClients: (id, data) => dispatch(updateClients(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProject);


